import React from 'react';
import { WireConfirmation } from '../../../models/FlowOfFunds/wire-confirmation.model';
import { getPartyName } from '../../../slices/marketplace/timeline/models/enums/timeline-party.enum';
import { formatDateTime } from '../../../utils/flowOfFundsFormat';

export interface ConfirmationMetaProps {
    confirmation: WireConfirmation | null;
}

export const ConfirmationMeta = ({ confirmation }: ConfirmationMetaProps) => {
    if (!confirmation) {
        return null;
    }
    return (
        <span className="ff-wires__confirm-meta">
            {getPartyName(confirmation.party)} · {formatDateTime(confirmation.confirmedAt)}
        </span>
    );
};
